import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class HashtagClickBehavior extends BaseOption {
  static optionValues = {
    authorProfile: "authorProfile",
    postPage: "postPage",
    notALink: "notALink",
    hashtagPage: "hashtagPage",
  };

  static userInterfaceComponent = {
    label: "Click Behavior",
    component: inspectorTools.SIMPLE_PICKER,
    displayOverrideIcon: false,
    props: {
      options: [
        {
          id: this.optionValues.authorProfile,
          name: "Author Profile",
        },
        {
          id: this.optionValues.postPage,
          name: "Story Page",
        },
        {
          id: this.optionValues.notALink,
          name: "Not a Link",
        },
        {
          id: this.optionValues.hashtagPage,
          name: "Hashtag Page",
        },
      ],
    },
  };

  static hashtagHref(baseUrl, idMapping, optionValue) {
    switch (optionValue) {
      case this.optionValues.authorProfile:
        return `${baseUrl}/user-profile/${idMapping.authorProfile}`;
      case this.optionValues.postPage:
        return `${baseUrl}/story/${idMapping.postPage}`;
      case this.optionValues.hashtagPage:
        return `${baseUrl}/stories/${idMapping.hashtagPage}`;
      default:
        return "#";
    }
  }

  static defaultValue = "postPage";
}
